import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LayoutComponent from "../../Layout/LayoutComponent";
import CommonFooter from "../Footer/CommonFooter";
import routes from "../../AppRoutes/routes.json";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <LayoutComponent>
      <Box
        sx={{
          width: "100%",
          minHeight: "55vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 2,
          py: 8,
        }}
      >
        <Typography
          sx={{
            fontFamily: "DM Sans",
            fontSize: { xs: "64px", md: "96px" },
            fontWeight: 700,
            color: "#EC1B24",
            lineHeight: 1,
            mb: 1,
          }}
        >
          404
        </Typography>
        <Typography
          sx={{
            fontFamily: "DM Sans",
            fontSize: { xs: "22px", md: "28px" },
            fontWeight: 600,
            color: "#232121",
            mb: 1.5,
          }}
        >
          Page not found
        </Typography>
        <Typography
          sx={{
            fontFamily: "DM Sans",
            fontSize: { xs: "14px", md: "16px" },
            color: "#5e5b5b",
            maxWidth: 420,
            mb: 3,
          }}
        >
          The page you are looking for does not exist or is no longer available.
        </Typography>
        <Button
          variant="contained"
          onClick={() => {
            sessionStorage.clear();
            navigate(routes.Home);
          }}
          sx={{
            fontFamily: "DM Sans",
            textTransform: "none",
            backgroundColor: "#EC1B24",
            px: 3,
            py: 1,
            "&:hover": { backgroundColor: "#c4161e" },
          }}
        >
          Go to Home
        </Button>
      </Box>
      <CommonFooter />
    </LayoutComponent>
  );
};

export default NotFound;
